//Library
import React, { Component } from 'react';
//redux
import { connect } from 'react-redux';
import { getCombinList, getFAQ } from '../../action/anueInfoAction';

import OnePlus from './OnePlus';
import RetirementTrial from './RetirementTrial';
import SpecificBrand from './SpecificBrand';
import InvestGroup from './InvestGroup';
import ActivityMethod from './ActivityMethod';
import FAQ from './FAQ'
class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      trialAnswer: undefined,
      trialGid: "",
      isOverRange: false
    }
  }

  componentWillMount() {
    if (this.props.CombinList === undefined) {
      this.props.getCombinList();
    }
    if (this.props.FAQInfo.length === 0) {
      this.props.getFAQ();
    }
  }

  componentDidMount() {
    if (window.location.hash !== "") {
      try {
        let hashID = window.location.hash.replace("#", "");
        let elm = document.getElementById(hashID);
        if (elm) {
          let top = elm.offsetTop;
          document.documentElement.scrollTop = top;
        }
      } catch (e) { }
    }
  }

  setTrialAnswer(trial) {
    let arr = ["保守", "穩健", "積極"];
    for (let i = 0; i <= arr.length - 1; i++) {
      let range = this.props.CombinList[i].median.replace(/%/g, "").split("~");
      if ((Number(range[0]) / 100) <= trial && (Number(range[1]) / 100) >= trial) {
        this.setState({ trialAnswer: trial, trialGid: this.props.CombinList[i].gid, isOverRange: false });
        return;
      }
    }
    this.setState({ trialAnswer: trial, trialGid: "none", isOverRange: true });
  }

  render() {
    return <div style={{ overflowX: 'hidden' }}>
      <OnePlus />
      <RetirementTrial setTrialAnswer={trial => { this.setTrialAnswer(trial) }} />
      <InvestGroup CombinList={this.props.CombinList} trialAnswer={this.state.trialAnswer} trialGid={this.state.trialGid} isOverRange={this.state.isOverRange} />
      <SpecificBrand />
      <ActivityMethod />
      <FAQ FAQInfo={this.props.FAQInfo} />
    </div>;
  }
}
function mapStateToProps(state) {
  return {
    CombinList: state.anueInfoState.CombinList,
    FAQInfo: state.anueInfoState.FAQInfo,
  };
}

export default connect(mapStateToProps, { getCombinList, getFAQ })(Home);